import React from 'react';
import classNames from 'classnames';
import Tooltip from '~/ui/components/Tooltip';
import { TooltipButtonVariants } from './TooltipButtonVariants';
import { TooltipButtonSizes } from './TooltipButtonSizes';
import type { TooltipButtonProps } from './types';

import './tooltipbutton.scss';

function TooltipButton({
    children,
    className,
    style = {},
    disabled = false,
    size = 'default',
    variant = 'default',
    visible = true,
    tooltipMessage = '',
    tooltipPlacement = 'bottom',
    tooltipContentSx,
    alignItems = 'center',
    flexDirection,
    flexWrap,
    justifyContent = 'center',
    onClick,
    onMouseEnter,
    onMouseLeave,
    isSubmit,
    ...extra
}: TooltipButtonProps): JSX.Element | null {
    function getClassName() {
        const defaultClassName = 'tooltipbutton';
        const conditionalClasses = {
            [`${defaultClassName}_${size}`]: size,
            [`${defaultClassName}_${variant}`]: variant,
            '_d-flex': true,
            [`_fd-${flexDirection}`]: flexDirection,
            [`_fw-${flexWrap}`]: flexWrap,
            [`_jc-${justifyContent}`]: justifyContent,
            [`_ai-${alignItems}`]: alignItems
        };
        return classNames(defaultClassName, conditionalClasses, className);
    }

    if (!visible) return null;

    return (
        <Tooltip
            contentSx={tooltipContentSx}
            content={tooltipMessage}
            placement={tooltipPlacement}
        >
            <button
                className={getClassName()}
                type={isSubmit ? 'submit' : 'button'}
                style={style}
                disabled={disabled}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                aria-label={extra['aria-label']}
                data-testid={extra['data-testid'] || 'tooltipbutton'}
            >
                {children}
            </button>
        </Tooltip>
    );
}

TooltipButton.sizes = TooltipButtonSizes;

TooltipButton.variants = TooltipButtonVariants;

export default TooltipButton;
